export default __webpack_public_path__ + "static/media/spain.879b33f3.webp";